import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { objectId } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const GenerationMode = { Agent: "agent", Template: "template" } as const;
export type GenerationMode =
  (typeof GenerationMode)[keyof typeof GenerationMode];

export const ClassifierAction = {
  ScenarioOutreach: "scenario-outreach",
  ScenarioReply: "scenario-reply",
  Fallback: "fallback",
  NoReply: "no-reply",
} as const;
export type ClassifierAction =
  (typeof ClassifierAction)[keyof typeof ClassifierAction];

export const fallbackSchema = z.object({
  mode: createEnum(GenerationMode, { enumName: "GenerationMode" }),
  template: z.string(),
  customInstructions: z.string().optional(),
});
const fallbackSchema_ = fallbackSchema;

const recoverConfigSchema_ = z.object({
  _id: objectId(),
  teamId: objectId(),
  name: z.string(),
  discountId: objectId().nullish(),
  brandName: z.string().optional(),
  /** Use Commerce Agent to write the initial outreach from the scenario template guidance. */
  agentOutreachEnabled: z.boolean().default(false),
  outreachTemplate: z.string(),
  /** Flattened reply template. Null/absent means replies use `fallback`. */
  replyTemplate: z.string().nullish(),
  /** Used when the reply classifier can't route to the reply template. */
  fallback: fallbackSchema_,
  /**
   * Minimum age required before Recover reply generation can proceed.
   * Null or undefined means the SMS age gate is disabled.
   */
  ageGateYears: z.number().int().positive().max(120).nullish(),
  /**
   * Schema of the trigger that drives this recover step. Determines which
   * dynamic variables are available in the message editor. Captured at config
   * creation time from the flow editor; legacy configs with no value default
   * to MARKETING_CHECKOUT_ABANDONMENT at read time.
   */
  schemaType: createEnum(SchemaType, { enumName: "SchemaType" }).optional(),
});
export const recoverConfigSchema: z.ZodType<RecoverConfig> =
  recoverConfigSchema_;
export interface RecoverConfig extends z.infer<typeof recoverConfigSchema_> {}
